import { motion } from "framer-motion";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import cx from "classnames";

import style from "./BottomBar.module.scss";
import { displayModal, displayUI } from "../../storage/emitter";
import { fade } from "../../storage/motionAnimations";
import { useEffect } from "react";

const RouterButton = ({ icon, to, onClick, exact, isActive, strict }) => {
  if (to) {
    return (
      <NavLink
        className="bar-button"
        exact={exact}
        to={to}
        strict={strict}
        onClick={onClick}
        isActive={isActive}
      >
        <span className={cx("icon", icon)} />
      </NavLink>
    );
  }
  return (
    <div className="bar-button" onClick={onClick}>
      <span className={cx("icon", icon)} />
    </div>
  );
};

const tabs = [
  {
    icon: "home",
    to: "/",
    exact: true,
  },
  {
    icon: "music",
    to: "/music",
    // onClick: () => {
    //   displayModal("demo");
    // },
  },
  {
    icon: "series",
    to: "/vod",
    isActive: (match, location) => {
      if (!location) return false;
      const { pathname } = location;
      return (
        pathname.includes("vod") ||
        pathname.includes("asset") ||
        pathname.includes("player")
      );
    },
  },
  {
    icon: "livetv",
    to: "/live",
    // onClick: () => {
    //   displayModal("demo");
    // },
  },
  {
    icon: "apps",
    to: "/apps",
    // onClick: () => {
    //   displayModal("demo");
    // },
  },
  {
    icon: "settings",
    to: "/settings",
    // onClick: () => {
    //   displayModal("demo");
    // },
  },
];

export default function BottomBar() {
  const { pathname } = useLocation();

  useEffect(() => {
    // make sure the UI is displayed on every path-change
    displayUI();
  }, [pathname]);

  return (
    <motion.footer
      className={cx("bar", "bottom-bar", style.bar)}
      variants={fade}
      initial="visible"
      animate="visible"
      exit="exit"
    >
      <div className={style.tabs}>
        {tabs.map((tab) => (
          <RouterButton key={tab.icon} {...tab} />
        ))}
      </div>
    </motion.footer>
  );
}
